import script from "./KemaskiniPemilikDialog2.vue?vue&type=script&setup=true&lang=js"
export * from "./KemaskiniPemilikDialog2.vue?vue&type=script&setup=true&lang=js"

import "./KemaskiniPemilikDialog2.vue?vue&type=style&index=0&id=b8dea21a&lang=css"

const __exports__ = script;

export default __exports__